/* eslint-disable no-param-reassign */
import Handsontable from 'handsontable';
import numbro from 'numbro';

// from @qvalia/isnum
export const isNumeric = (num: any) =>
  typeof num !== 'object' &&
  !Number.isNaN(+String((String(num) || '').replace(/[^0-9.\-e]/, '') !== String(num) || num === '' ? NaN : num));

// adapted from handsontable/src/renderers/numericRenderer/numericRenderer.js
export function getRenderedValue(value: any, numericFormat: Handsontable.CellProperties['numericFormat']) {
  if (!isNumeric(value)) {
    return value;
  }
  const cellCulture = (numericFormat && numericFormat.culture) || '-';
  const cellFormatPattern = numericFormat && (numericFormat.pattern as numbro.Format);

  if (typeof cellCulture !== 'undefined' && !numbro.languages()[cellCulture]) {
    const shortTag = cellCulture.replace('-', '');
    const langData = numbro.languages() ? numbro.languages()[cellCulture] : numbro[shortTag];

    if (langData) {
      numbro.registerLanguage(langData);
    }
  }

  numbro.setLanguage(cellCulture);

  return numbro(value).format(cellFormatPattern || '0');
}

type NumericRenderer = typeof Handsontable.renderers.NumericRenderer;

export const decimalRenderer: NumericRenderer = (instance, td, row, col, prop, value, cellProperties) => {
  /* Run original Handsontable renderer to ensure styles look right */
  Handsontable.renderers.NumericRenderer(instance, td, row, col, prop, value, cellProperties);

  /* the value is not present or not a number, Handsontable's rendering is enough */
  if (!(value && isNumeric(value))) {
    return;
  }

  /* if users provided a string literal pattern, pass it to numbro directly */
  if (typeof cellProperties.numericFormat?.pattern === 'string') {
    td.innerHTML = `${getRenderedValue(value, cellProperties.numericFormat)}%`;
    return;
  }

  /*
    if numericFormat.pattern is not a string, it's an object, either provided
    by users or the default ink percent column settings, which we need to override
    by setting {output: 'number'}.
  */
  const numberPattern = {
    ...cellProperties.numericFormat,
    pattern: { ...cellProperties.numericFormat?.pattern, output: 'number' as const },
  };
  td.innerHTML = `${getRenderedValue(value, numberPattern)}%`;
};
